import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ErrorModal from "../../../utils/ErrorModal";
import { CURRENCY_INR } from "../../../utils/constant";

const AddCurrency = () => {
  const [orgCurrencies, setOrgCurrencies] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrencyId, setSelectedCurrencyId] = useState("");
  const [rate, setRate] = useState();
  const [editingRates, setEditingRates] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const { orgId } = useParams();
  const admin = JSON.parse(localStorage.getItem("admin"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    fetchCurrencies();
    fetchOrgCurrencies();
  }, []);

  const fetchCurrencies = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/currency`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setCurrencies(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchOrgCurrencies = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/org-currency?orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOrgCurrencies(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddCurrency = async () => {
    if (!selectedCurrencyId || !rate) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/org-currency`,
        {
          orgId: orgId,
          currencyId: selectedCurrencyId,
          rate: parseFloat(rate),
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSelectedCurrencyId("");
      setRate("");
      fetchOrgCurrencies();
    } catch (err) {
      setErrorModal(true);
      setErrorMsg("Currency already added. Please edit instead.");
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdateRate = async (orgCurrencyId) => {
    const updatedRate = editingRates[orgCurrencyId];
    if (!updatedRate) return;
    setBtnLoading(true);

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/org-currency?id=${orgCurrencyId}`,
        { rate: parseFloat(updatedRate) },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      fetchOrgCurrencies();
    } catch (err) {
      console.error(err);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-outlined"
          onClick={() =>
            navigate(`/superadmin-dashboard/${orgId}/admin-dashboard`)
          }
        >
          Back
        </Button>
      </div>
      <div className="dashboard-container">
        <h2>Add Currency</h2>
        <div style={{ display: "flex", columnGap: 25 }}>
          <select
            value={selectedCurrencyId}
            onChange={(e) => setSelectedCurrencyId(e.target.value)}
          >
            <option value="">Select Currency</option>
            {currencies.map((cur) => (
              <option key={cur.currencyId} value={cur.currencyId}>
                {cur.name} ({cur.shortform})
              </option>
            ))}
          </select>
          <input
            type="number"
            step="0.01"
            min="0"
            placeholder="Conversion Rate to Indian Rupee(INR)"
            value={rate}
            style={{ width: "50%" }}
            onChange={(e) => {
              if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                setRate(e.target.value);
              }
            }}
          />
          <Button
            sx={{ margin: "5px 0 20px 0 !important", width: "50%" }}
            className="btn-contained"
            onClick={handleAddCurrency}
          >
            Add
          </Button>
        </div>
        <p style={{ fontSize: "14px", fontWeight: "bold" }}>
          [Note: Only currencies with conversion rate added are shown to
          vendors.]
        </p>

        <h2 style={{ marginTop: "30px" }}>Organization Currencies</h2>
        <table
          border={1}
          style={{
            borderCollapse: "collapse",
            width: "100%",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              <th style={{ padding: "20px", width: "25%" }}>Currency</th>
              <th style={{ width: "25%" }}>Code</th>
              <th style={{ width: "25%" }}>Rate (in &#8377;)</th>
              <th style={{ width: "25%" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {orgCurrencies.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ padding: "20px", textAlign: "center" }}
                >
                  No currencies added yet.
                </td>
              </tr>
            ) : (
              orgCurrencies.map((item) => (
                <tr key={item.id}>
                  <td style={{ padding: "20px" }}>{item.currency.name}</td>
                  <td>{item.currency.shortform}</td>
                  <td>
                    {item.currency.shortform !== CURRENCY_INR ? (
                      <input
                        className="table-input"
                        type="number"
                        step="0.01"
                        value={editingRates[item.id] ?? item.rate}
                        onChange={(e) => {
                          if (/^\d*\.?\d{0,2}$/.test(e.target.value)) {
                            setEditingRates((prev) => ({
                              ...prev,
                              [item.id]: e.target.value,
                            }));
                          }
                        }}
                      />
                    ) : (
                      item.rate
                    )}
                  </td>
                  <td>
                    {item.currency.shortform !== CURRENCY_INR && (
                      <Button
                        className="btn-outlined"
                        sx={{ margin: "0 !important" }}
                        onClick={() => handleUpdateRate(item.id)}
                      >
                        Update
                      </Button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ErrorModal
        open={errorModal}
        handleClose={() => setErrorModal(false)}
        msg={errorMsg}
      />
    </div>
  );
};

export default AddCurrency;
